import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { LocLabel } from '../../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss']
})
export class CheckboxInputComponent implements ControlValueAccessor {
  @Input() labelKey: string | LocLabel | null | undefined;
  @Input() disabled = false;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() padded = true;

  private _value: any;

  constructor(public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  // this method sets the value programmatically
  public writeValue(value: any) {
    if (value !== this._value) {
      this._value = value;
    }
  }

  get value(): any {
    return this._value;
  }

  set value(value: any) {
    this.writeValue(value);
    this.onChange(value);
    this.onTouch(value);
  }

  // upon UI element value changes, this method gets triggered
  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // upon touching the element, this method gets triggered
  public registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  public onChange: any = (value: any) => (this.value = value);
  public onTouch: any = () => {};
}
